var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mail-info col-md-12 flex mt-4 mail-green" },
    [
      _c("div", { staticClass: "col-md-9 flex align-items-center" }, [
        _c("span", { staticClass: "flex" }, [
          _c("span", [
            _vm._m(0),
            _vm._v(" "),
            _c("span", { staticClass: "refund-msg" }, [
              _vm._v(
                "\n          $" +
                  _vm._s(_vm.refundTotals.join(", $")) +
                  "\n        "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "col-md-3 text-right flex justify-content-center align-items-center"
        },
        [
          _c(
            "router-link",
            {
              staticClass: "text-decoration-none",
              attrs: { to: "/jobs/edit/" + _vm.claim.job.id }
            },
            [
              _c("span", { staticClass: "flex" }, [
                _c("p", { staticClass: "pr-2 m-t text-dark" }, [
                  _vm._v("See job")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "m-t" }, [
                  _c("i", {
                    staticClass: "fa fa-arrow-right claim-refund-icon-arrow"
                  })
                ])
              ])
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", { staticClass: "fa fa-check claim-refund-icon-checkmark" }),
      _vm._v(" Customer has been refunded for\n        ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f51f392", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f51f392","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/claims/ClaimRefunds.vue
// module id = null
// module chunks = 